import Swiper from 'swiper/bundle';

export default class Carousels {
	constructor(){
		this.carousel = {
			multiple_items: document.querySelectorAll('.carousel[data-carousel="multiple-items"]'),
            grid_items: document.querySelectorAll('.carousel[data-carousel="grid-items"]'),
		};
	}

	init() {
		this.galleryHome();
	}

    galleryHome() {
        var swiper = new Swiper(".swiper-container", {
            slidesPerView: 1,
            spaceBetween: 40,
            slidesPerGroup: 1,
            loop: true,
            dots: true,
            loopFillGroupWithBlank: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

    }

}
